import { ProjectSectionListItem } from '@modules/projects/components/Sections/ProjectSectionList';
import { ListItemButton, ListItemProps, ListItemText, Stack, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import { ProjectTaskFragmentFragment, ProjectTaskStatus } from 'src/gql/index';
import { getTenantIdentifier } from '../../../utils/getTenantIdentifier';
import { useCurrentProject } from '../../projects/utils/useCurrentProject';
import { useTaskFormatters } from '../useTaskFormatters';

type CustomTaskListItemProps = ListItemProps & {
  task: ProjectTaskFragmentFragment;
  onOpenTask?: (task: ProjectTaskFragmentFragment, projectId: number) => void;
  secondaryAction?: React.ReactNode;
  assigneesAdornment?: React.ReactNode;
};


export const CustomTaskListItem = (props: CustomTaskListItemProps) => {
  const { task, onOpenTask, secondaryAction, assigneesAdornment, ...listItemProps } = props;
  const projectContext = useCurrentProject({ disabled: task.projectId != null });
  const resolvedProjectId = task.projectId ?? projectContext.projectId;
  const { formatTaskSecondaryText } = useTaskFormatters();
  const navigate = useNavigate();
  const dueDate = task.dueDate ?? task.startDate;

  const isOverdue = task.status !== ProjectTaskStatus.Done && (dueDate ? dayjs(dueDate).isBefore(dayjs(), 'day') : false);

  const secondary = formatTaskSecondaryText(task);

  const handleClick = () => {
    if (onOpenTask && resolvedProjectId) {
      onOpenTask(task, resolvedProjectId);
      return;
    }

    navigate(`/${getTenantIdentifier()}/projects/${resolvedProjectId}/tasks/${task.id}`);
  };
  return <>
    <ProjectSectionListItem
      disablePadding
      key={task.id}
      {...listItemProps}
      secondaryAction={secondaryAction}
      onClick={undefined}
    >

      <ListItemButton onClick={handleClick}>

        <ListItemText
          primary={
            <Stack direction='row' alignItems='center' spacing={1} minWidth={0}>
              <Typography noWrap>{task.name}</Typography>
              {assigneesAdornment}
            </Stack>
          }
          secondary={
            <Tooltip title={secondary || undefined}>
              <Typography noWrap color={isOverdue ? 'error' : 'inherit'}>{secondary}</Typography>
            </Tooltip>
          }
          secondaryTypographyProps={{ color: isOverdue ? 'error' : 'inherit' }}
          primaryTypographyProps={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        />
      </ListItemButton>
    </ProjectSectionListItem >
  </>;
};